<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Product Replacement Target Dates
      </h2>
      <p class="tw-italic tw-text-gray-700">

      </p>
    </b-container>
    <hr>
    <b-row>
      <b-col cols="3">
      <b-form-group
          id="fieldset-1"
          label="Selected Period"
          label-for="input-1"
        >
          <b-select :options="period_options" v-model="selected_period"></b-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
      <b-form-group
          id="fieldset-1"
          label="Placed Status"
          label-for="input-1"
        >
          <b-select :options="placed_options" v-model="selected_placed_status"></b-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
      <b-form-group
          id="fieldset-1"
          label="Cluster"
          label-for="input-1"
        >
          <b-select :options="cluster_options" v-model="selected_cluster"></b-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
      <b-form-group
          id="fieldset-1"
          label="Target Date"
          label-for="input-1"
        >
          <b-datepicker v-model="selected_target_date"></b-datepicker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <small>Total: {{ totalRows }} </small>
      </b-col>
      <b-col style="text-align: right; padding-right: 20px;">
        <b-button class="btn bt-sm btn-success" style="font-size: 12px; position: relative; bottom: 10px;" @click="downloadData"><i class="fa fa-download"></i> CSV</b-button>
      </b-col>
    </b-row>
    <b-table
      ref="table"
      striped
      hover
      :fields="fields"
      :items="myProvider"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:cell(id)="data">
          <!-- set to aegis-sri-lanka -->
          <b-link :href="'https://www.commcarehq.org/a/aegis-sri-lanka/reports/case_data/'+data.item.id+'/'" target="_blank">CommCare <i class="fa fa-external-link-alt"></i></b-link>
      </template>

    </b-table>
    <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "id", label: "Link", sortable: false },
        { key: "compound_id", label: "Compound ID", sortable: false },
        { key: "structure_code", sortable: false },
        { key: "cluster_number", label: "Cluster", sortable: false },
        { key: "placement_period", label: "Period", sortable: false },
        { key: "number_products_placed", label: "Number Products Placed", sortable: false },
        { key: "placement_target_date", label: "Target Date", sortable: false },
        { key: "products_placed", label: "Products Placed", sortable: false },
      ],
      perPage: 15,
      totalRows: 0,
      currentPage: 1,
      events: [],
      selected_period: null,
      period_options: [
        {value: null, text: 'All'},
        {value: 1, text: 'Period 1'},
        {value: 2, text: 'Period 2'},
        {value: 3, text: 'Period 3'},
        {value: 4, text: 'Period 4'},
        {value: 5, text: 'Period 5'},
        {value: 6, text: 'Period 6'},
        {value: 7, text: 'Period 7'},
        {value: 8, text: 'Period 8'},
        {value: 9, text: 'Period 9'},
        {value: 10, text: 'Period 10'},
        {value: 11, text: 'Period 11'},
        {value: 12, text: 'Period 12'},
      ],
      placed_options: [
        {value: null, text: 'Any'},
        {value: 'not placed', text: 'Not Placed'},
        {value: 'placed', text: 'Placed'}
      ],
      selected_placed_status: 'not placed',
      selected_cluster: null,
      cluster_options: [
        {value: null, text: 'All'},
      ],
      selected_target_date: null,
      sortBy: "id",
      sortDesc: false,
    };
  },
  computed: {},
  watch: {
    selected_cluster: function(){
      this.currentPage = 1;
      this.$refs.table.refresh();
    },
    selected_period: function(){
      this.currentPage = 1;
      this.$refs.table.refresh();
    },
    selected_placed_status: function(){
      this.currentPage = 1;
      this.$refs.table.refresh();
    },
    selected_target_date: function(){
      this.currentPage = 1;
      this.$refs.table.refresh();
    }
  },
  created: function() {
    this.period_options = [
        {value: null, text: 'All'},
        {value: 1, text: 'Period 1'},
        {value: 2, text: 'Period 2'},
        {value: 3, text: 'Period 3'},
        {value: 4, text: 'Period 4'},
        {value: 5, text: 'Period 5'},
        {value: 6, text: 'Period 6'},
        {value: 7, text: 'Period 7'},
        {value: 8, text: 'Period 8'},
        {value: 9, text: 'Period 9'},
        {value: 10, text: 'Period 10'},
        {value: 11, text: 'Period 11'},
        {value: 12, text: 'Period 12'},
        {value: 13, text: 'Period 13'},
        {value: 14, text: 'Period 14'},
        {value: 15, text: 'Period 15'},
        {value: 16, text: 'Period 16'},
        {value: 17, text: 'Period 17'},
        {value: 18, text: 'Period 18'},
        {value: 19, text: 'Period 19'},
        {value: 20, text: 'Period 20'},
        {value: 21, text: 'Period 21'},
        {value: 22, text: 'Period 22'},
        {value: 23, text: 'Period 23'},
        {value: 24, text: 'Period 24'},
      ]
  },
  mounted: function() {
    for(var i = 1; i <= 60; i++){
      this.cluster_options.push({
        value: i,
        text: 'Cluster ' + i
      })
    }
  },
  methods: {
    find: function(){
      this.$refs.table.refresh();
    },
    downloadData(){
      let that = this;
      let params = {
        period: this.selected_period,
        placed_status: this.selected_placed_status,
        cluster: this.selected_cluster,
        target_date: this.selected_target_date,
        return_type: 'csv'
      }

      HTTP.get("/srilanka/product_replacements/get_target_list_csv", {
        params: params
      }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          var filename = 'ProductReplacements_';
          if(that.selected_period){
            filename += 'Period'+that.selected_period+'_';
          }
          else{
            filename += 'AllPeriods_';
          }
          if(that.selected_placed_status){
            filename += that.selected_placed_status.replace(' ', '')+'_';
          }
          else{
            filename += 'AnyPlacedStatus_';
          }
          if(that.selected_cluster){
            filename += 'Cluster'+that.selected_cluster;
          }
          else{
            filename += 'AllClusters';
          }
          if(that.selected_target_date){
            filename += '_TargetDate_'+that.selected_target_date;
          }
          filename += '.csv'
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    myProvider: function(ctx){
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        descending: ctx.sortDesc,
        period: this.selected_period,
        placed_status: this.selected_placed_status,
        cluster: this.selected_cluster,
        target_date: this.selected_target_date
      }

      return HTTP.get("/srilanka/product_replacements/get_target_list", {
        params: params
      }).then(response => {
        let events = [];
        _.each(response.data.cases, function(item){
          events.push(item);
        });
        that.totalRows = response.data.totalRows;
        return events;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
</style>